// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/icons/down-arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select-box {
  position: relative;
  height: 2rem;
  z-index: 999;
}
.custom-select-box.disabled {
  pointer-events: none;
}
.custom-select-box .select-el {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1001;
  display: inline-block;
  min-height: 2rem;
  max-height: 2rem;
  overflow: hidden;
  cursor: pointer;
  text-align: left;
  white-space: nowrap;
  outline: none;
  border: 2px solid var(--buttonBg);
  border-radius: 0.5rem;
  background-color: var(--primaryHover);
  color: var(--white);
  transition: 0.3s all ease-in-out;
  width: 100%;
  padding: 0 1.8rem 0 0.5rem;
}
.custom-select-box .select-el span {
  display: block;
  line-height: 1.9rem;
  cursor: pointer;
  position: relative;
  transition: 0.3s color ease-in-out;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
}
.custom-select-box .select-el::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  position: absolute;
  right: 5px;
  top: 3px;
  transition: 0.4s all ease-in-out;
}
.custom-select-box .select-el.expanded {
  background-color: var(--TabBgActive);
  box-shadow: rgba(0, 0, 0, 0.1) 3px 3px 5px 0px;
  max-height: 15em;
}
.custom-select-box .select-el.expanded span:not(:first-child) {
  color: var(--white-5);
}
.custom-select-box .select-el.expanded span:hover {
  color: var(--white);
}
.custom-select-box .select-el.expanded::after {
  transform: rotatex(-180deg);
  top: 3px;
  opacity: 0.4;
}
@media only screen and (max-width: 768px) {
  .custom-select-box .select-el.toggle-md-icon-none {
    padding: 0 0.5rem 0 0.5rem;
  }
  .custom-select-box .select-el.toggle-md-icon-none::after {
    content: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ui-kit/SelectBox/SelectBox.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AACF;AAAE;EACE,oBAAA;AAEJ;AAAE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,iCAAA;EACA,qBAAA;EACA,qCAAA;EACA,mBAAA;EACA,gCAAA;EACA,WAAA;EACA,0BAAA;AAEJ;AADI;EACE,cAAA;EAEA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAEN;AAAI;EACE,gDAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,gCAAA;AAEN;AAAI;EACE,oCAAA;EACA,8CAAA;EACA,gBAAA;AAEN;AAAQ;EACE,qBAAA;AAEV;AAEQ;EACE,mBAAA;AAAV;AAGM;EACE,2BAAA;EACA,QAAA;EACA,YAAA;AADR;AAII;EACE;IACE,0BAAA;EAFN;EAGM;IACE,cAAA;EADR;AACF","sourcesContent":[".custom-select-box {\n  position: relative;\n  height:2rem;\n  z-index: 999;\n  &.disabled {\n    pointer-events: none;\n  }\n  .select-el {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: 1001;\n    display: inline-block;\n    min-height: 2rem;\n    max-height: 2rem;\n    overflow:hidden;\n    cursor: pointer;\n    text-align: left;\n    white-space: nowrap;\n    outline: none;\n    border: 2px solid var(--buttonBg);\n    border-radius: 0.5rem;\n    background-color: var(--primaryHover);\n    color: var(--white);\n    transition: 0.3s all ease-in-out;\n    width: 100%;\n    padding: 0 1.8rem 0 0.5rem;\n    span {\n      display:block;\n      // height: 2.3rem;\n      line-height: 1.9rem;\n      cursor: pointer;\n      position: relative;\n      transition: 0.3s color ease-in-out;\n      text-overflow: ellipsis;\n      overflow: hidden;\n      font-size: 12px;\n    }\n    &::after {\n      content: url('/assets/icons/down-arrow.svg');\n      position: absolute;\n      right: 5px;\n      top: 3px;\n      transition: .4s all ease-in-out;\n    }\n    &.expanded {\n      background-color: var(--TabBgActive);\n      box-shadow: rgba(0, 0, 0, 0.1) 3px 3px 5px 0px;\n      max-height:15em;\n      span {\n        &:not(:first-child) {\n          color: var(--white-5);\n        }\n      }\n      span {\n        &:hover {\n          color: var(--white);\n        }\n      }\n      &::after {\n        transform: rotatex(-180deg);\n        top: 3px;\n        opacity: 0.4;\n      }\n    }\n    @media only screen and (max-width: 768px) {\n      &.toggle-md-icon-none {\n        padding: 0 0.5rem 0 0.5rem;\n        &::after {\n          content: unset;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
